import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import adminApi from "../api/adminApi";
import AdminLayout from "./AdminLayout";
import CategoriesAdmin from "./CategoriesAdmin";
import Dashboard from "./Dashboard";
import Login from "./Login";
import ProjectForm from "./ProjectForm";
import ProjectsAdmin from "./ProjectsAdmin";
import SecuritySettings from "./SecuritySettings";
import UserRegistration from "./UserRegistration";
import "./admin.css";

function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!adminApi.getAccessToken()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}

function SecuredLayout() {
  return (
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  );
}

export default function AdminApp() {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    async function restoreSession() {
      if (!adminApi.getAccessToken() && adminApi.getRefreshToken()) {
        try {
          await adminApi.refreshAccessToken();
        } catch {
          adminApi.logout();
        }
      }
      if (active) setChecking(false);
    }
    restoreSession();
    const handleExpired = () =>
      navigate("/admin/login", { replace: true, state: { expired: true } });
    window.addEventListener("sunpledge:session-expired", handleExpired);
    return () => {
      active = false;
      window.removeEventListener("sunpledge:session-expired", handleExpired);
    };
  }, [navigate]);

  if (checking) {
    return (
      <div className="admin-auth-loading">
        <div className="admin-spinner" />
        <p>Restoring secure session…</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<SecuredLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<ProjectsAdmin />} />
        <Route path="projects/new" element={<ProjectForm />} />
        <Route path="projects/:id/edit" element={<ProjectForm />} />
        <Route path="categories" element={<CategoriesAdmin />} />
        <Route path="security" element={<SecuritySettings />} />
        <Route path="users/new" element={<UserRegistration />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
